import React from 'react'
import "../ComponentsCSS/About.css"
import Form from './Form'
import { Link } from 'react-router-dom'
import SEO from './SEO'

const About = () => {
  return (
    <div className="about-page mt-5">
      <SEO
        title="About Us | SASK A One Shuttle | Prince Albert Transportation"
        description="Learn about SASK A One Shuttle, our professional class 4 licensed drivers, and our commitment to safe and reliable transit services in Saskatchewan."
        keywords="about Sask A One Shuttle, Prince Albert transit, Saskatchewan professional drivers, wheelchair transport Saskatchewan"
      />
      <header className="about-header" data-aos="slide-up">
        <p className="tagline">Looking for a top-notch Shuttle Service?</p>
        <h1>Welcome to SASK A One Shuttle</h1>
        <p className="lead">Serving Prince Albert and beyond with safe, friendly, and reliable transportation.</p>
      </header>

      <section className="ribbon" data-aos="fade-right">
        <span>Fast • Friendly • Reliable</span>
      </section>

      <section className="about-content">
        <div className="content-grid">
          <div className="content-block" data-aos="fade-right">
            <h2>About SASK A One Shuttle</h2>
            <p>
              Allow us to introduce ourselves. We are SASK A One Shuttle and our team is available for any job, from big to small
              whenever you need us. We do not just meet your expectations, we surpass them. SASK A One Shuttle serves the needs
              of residents in Prince Albert and the surrounding area.
            </p>
            <p>
              We have experienced drivers with Class 4 licenses who prioritize client safety and comfort. Trusted by
              organizations such as the Health Region, WCB, SGI, Sherbrooke, Parkridge, and more — we are the preferred choice for
              transportation in Prince Albert.
            </p>
          </div>
          <div className="content-block" data-aos="fade-left">
            <h2>Why Choose Us?</h2>
            <p>
              Our dedicated team works day and night to guarantee our customers receive only the best. What makes us
              stand out is our attention to detail, excellent pricing, and commitment to client satisfaction.
            </p>
            <p>
              We offer rides throughout Prince Albert and to major cities across Western Canada. Contact us to see how our
              professional team can assist you!
            </p>
          </div>
        </div>
      </section>

      <section className="services-section" data-aos="flip-up">
        <div className="services-container">
          <h2>Our Services</h2>
          <div className="services-grid">
            <div className="service-card">
              <h3>Local Shuttle Rides</h3>
              <p>Serving Prince Albert and surrounding areas for daily commutes, appointments, and more.</p>
            </div>
            <div className="service-card">
              <h3>Long-Distance Travel</h3>
              <p>Travel across Prince Albert or to Western Canada with comfort and confidence.</p>
            </div>
            <div className="service-card">
              <h3>Corporate Transport</h3>
              <p>Preferred transportation partner for healthcare institutions, care homes, and businesses.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="testimonials-section my-5" data-aos="zoom-out">
        <div className="testimonials-container text-center">
          <h2>Client Testimonials</h2>
          <p className="testimonials-subtitle">Here's what makes SASK A One Shuttle a top-rated service in Prince Albert:</p>
          <div className="testimonials-grid">
            <div className="testimonial" data-aos="fade-left">
              <blockquote>
                "The team is always on time, professional, and friendly. I trust them with my regular hospital visits!"
              </blockquote>
              <cite>– Sherbrooke Client</cite>
            </div>
            <div className="testimonial" data-aos="fade-right">
              <blockquote>
                "Affordable and extremely reliable. I recommend SASK A One Shuttle to anyone needing safe transportation."
              </blockquote>
              <cite>– Parkridge Staff</cite>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section" data-aos="slide-up">
        <h2>Need a ride?</h2>
        <p>Call us now and book your safe, comfortable trip today.</p>
        <Link to="/booknow" className="cta-button">Contact Us</Link>
      </section>
      
      <Form />
    </div>
  )
}

export default About